import {
  ThemesConfigResponseDto,
  UpdateContentPagesRequestDto,
} from '@tiendanube/common';
import { LIGHTSPEED_CUSTOM_PAGES_SECTIONS } from 'App/featuresFlags';
import { LanguageNameValueInterface } from 'App/i18n';
import useGetTags from 'domains/Auth/hooks/useGetTags';
import {
  SeoParametersCard,
  TitleAndContentCard,
  DesignEditSection,
} from './components';
import { LIGHTSPEED_THEMES } from '../../constants';

export interface FormPageProps {
  values: UpdateContentPagesRequestDto;
  errors: Partial<Record<string, string>>;
  themesConfig?: ThemesConfigResponseDto;
  onChange: (e: LanguageNameValueInterface) => void;
  onDesignEditClick: () => void;
}

function FormPage({
  values,
  errors,
  onChange,
  themesConfig,
  onDesignEditClick,
}: Readonly<FormPageProps>) {
  const tags = useGetTags();

  const hasLightspeedCustomPagesSections = tags.includes(
    LIGHTSPEED_CUSTOM_PAGES_SECTIONS,
  );
  const hasLightSpeedTheme =
    (!!themesConfig?.draft &&
      LIGHTSPEED_THEMES.includes(themesConfig.draft.code)) ||
    (!!themesConfig?.currentTheme &&
      LIGHTSPEED_THEMES.includes(themesConfig.currentTheme.code));

  return (
    <>
      <TitleAndContentCard
        values={values}
        errors={errors}
        onChange={onChange}
        bottomContent={
          hasLightspeedCustomPagesSections &&
          hasLightSpeedTheme && (
            <DesignEditSection onEditDesign={onDesignEditClick} />
          )
        }
      />
      <SeoParametersCard values={values} onChange={onChange} />
    </>
  );
}

export default FormPage;
